<template>
    <div class="container">
        <VueSignaturePad ref="signaturePad" class="signature" width="100%" height="200px"
            :options="{ minWidth: 4, maxWidth: 4, onBegin: () => { $refs.signaturePad.resizeCanvas() } }" />

        <div class="row d-flex justify-content-end mt-4">
            
            <base-button :disabled="isSignatureValid"  size="md" variant="warning" @click.native="clear"> Clear </base-button>

            <base-button size="md" variant="primary" @click.native="apply">Apply</base-button>
        </div>
    </div>
</template>

<script>
import Utility from "@/mixins/utility/utility";
import {mapGetters} from 'vuex'


export default {
    name: "alert-signature-draw",

    mixins: [Utility],
    props: ['drawData', 'hasSignature'],
    data: function () {
        return {
            options: {
                penColor: "#000000",
                minWidth: 2,
                maxWidth: 2
            },
            data: "",
            signatureHeight: "300px"
        }
    },
  
    computed: {
        ...mapGetters({
      isPartnerAccount: "authentication/isPartnerAccount",
      }) ,
      isSignatureValid (){
        if(this.hasSignature && this.hasSignature !=0 && this.isPartnerAccount ){
            return true
        }else{
            return false
        }
      }
    },

    methods: {
        load() {
            this.data = this.drawData;

            const signaturePad = this.$refs.signaturePad;
            if (!this.isNullOrEmpty(this.data)) {
                signaturePad.fromDataURL(this.data);
            }
        },
        clear() {
            const signaturePad = this.$refs.signaturePad;
            signaturePad.clearSignature();
        },
        apply() {
            this.$loaderApp.addRequest();
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();


            //generate the text Signature
            this.axios.post(`/api/signatures/graphical`, { signature: data }, { config: { showToast: false } })
                .then((response) => {
                    //Load the data
                    const signature = "data:image/jpg;base64," + response.data;

                    this.$emit('onDrawResult', { edit: data, view: signature });
                       this.$loaderApp.completeRequest();
                }).catch((err) => {
                       this.$loaderApp.completeRequest();
                    this.$toast.error("Error on generating the signature, Please try again later");
                })
        },
    }
}
</script>

<style scopped>
.signature {
    background-color: #FFFFFF;
    border: 2px solid lightgrey;
}


.block {
    display: block;
}
</style>
